import { render } from "./ValidateView.vue?vue&type=template&id=18bb73a6"
import script from "./ValidateView.vue?vue&type=script&lang=js"
export * from "./ValidateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__